export default __webpack_public_path__ + "static/media/blog-img211.b7f2f43d.jpg";